@if (isApplied()) {
  <visio-filter-chip [selected]="true" [close]="true" (close)="clear()">{{
    chipLabel()
  }}</visio-filter-chip>
} @else {
  <div class="property-filter">
    <span class="property-filter__label">{{ filter().label }}</span>
    <select
      class="property-filter__operator"
      [ngModel]="draft().operator"
      (ngModelChange)="updateDraftOperator($event)"
    >
      @for (op of filter().operators; track op) {
        <option [value]="op">{{ operatorSymbols[op] }}</option>
      }
    </select>
    <input
      class="property-filter__input"
      type="text"
      placeholder="Valor..."
      [ngModel]="draft().value"
      (ngModelChange)="updateDraftValue($event)"
      (keydown.enter)="submit()"
    />
  </div>
}
